var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, Skeleton, Typography, useTheme } from "@mui/material";
import { memo } from "react";
import { useSelector } from "react-redux";
// @ts-ignore
import { selectors } from "paul-core-package";
import { CompareTwoValues } from "../../CompareTwoValues";
import { DataTable } from "../../DataTable";
import { dataTableColumns } from "../constants";
export var EnergySavingItem = memo(function (_a) {
    var _b;
    var titleTransKey = _a.titleTransKey, comparingTwoValuesData = _a.comparingTwoValuesData, metricRows = _a.metricRows, metricsTableTitleTransKey = _a.metricsTableTitleTransKey;
    var theme = useTheme();
    var tI = useSelector(selectors.getActiveTranslationsInterfaceUILocalizations);
    var hiddenNegativeValueData = __assign(__assign({}, comparingTwoValuesData), { isHiddenNegativePercentage: true });
    return (_jsxs(Box, { children: [_jsx(Box, __assign({ mb: 7 }, { children: _jsx(Typography, __assign({ variant: "h5", color: theme.palette.grey[500] }, { children: (_b = tI[titleTransKey]) !== null && _b !== void 0 ? _b : (_jsx(Skeleton, { variant: "text", sx: { fontSize: "inherit", width: 300 } })) })) })), _jsxs(Grid, __assign({ container: true, gap: 5, flexWrap: "nowrap" }, { children: [_jsx(Grid, __assign({ item: true, sx: {
                            minWidth: "422px",
                        } }, { children: _jsx(CompareTwoValues, { data: hiddenNegativeValueData }) })), _jsx(Grid, __assign({ item: true, xs: true }, { children: _jsx(DataTable, { columns: dataTableColumns(tI), rows: metricRows, title: tI[metricsTableTitleTransKey] }) }))] }))] }));
});
